import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useStore } from 'src/stores/store';
import { RouteType } from '../types/navigationTypes';

/**
 * Lightweight hook for navigation that integrates React Router with Zustand store.
 * Use this hook only for the navigate function.
 * Use useStore() directly for all state access.
 */
export const useNavigation = () => {
	const history = useHistory();
	const { setCurrentView } = useStore();

	const navigate = useCallback(
		(view: RouteType, path: string) => {
			setCurrentView(view);
			history.push(path);
		},
		[history, setCurrentView]
	);

	return { navigate };
};
